export default "__VITE_ASSET__BGG4Copr__"